export const CustomerItems = [
  {
    text: '“Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small.”',
    personImg:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
    personName: 'Emre Ates',
    personJob: 'Frontend Developer',
  },
  {
    text: '“Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small.Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small.”',
    personImg:
      'https://images.unsplash.com/flagged/photo-1570612861542-284f4c12e75f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
    personName: 'Emre Ates',
    personJob: 'Frontend Developer',
  },
  {
    text: '“Even Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small. no control about the blind texts it is an almost unorthographic life One day however a small.”',
    personImg:
      'https://images.unsplash.com/photo-1499952127939-9bbf5af6c51c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1776&q=80',
    personName: 'Emre Ates',
    personJob: 'Frontend Developer',
  },
  {
    text: '“Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic”',
    personImg:
      'https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
    personName: 'Emre Ates',
    personJob: 'Frontend Developer',
  },
  {
    text: '“Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small.Even the all-powerful Pointt ever a small.”',
    personImg:
      'https://images.unsplash.com/photo-1573140247632-f8fd74997d5c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
    personName: 'Emre Ates',
    personJob: 'Frontend Developer',
  },
];
